// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
// import { Select, Option } from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import wx from 'weixin-js-sdk'
import { get } from './utils/request'

import VueScroller from 'vue-scroller'

Vue.config.productionTip = false

// Vue.component(Button.name, Button);
// Vue.component(Select.name, Select);
// Vue.component(Option.name, Option);

Vue.use(VueClipboard)
Vue.use(VueScroller)

localStorage.removeItem('token')

get('https://liuya.baichuanbailian.com/api/1.0/js-config', { url: encodeURI(location.href.split('#')[0]) }).then(res => {  
  wx.config({
    debug: false, // 开启调试模式,
    appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature,// 必填，签名，见附录1
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'previewImage', 'miniProgram.getEnv', 'miniProgram.navigateBack', 'miniProgram.postMessage', 'chooseWXPay'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2    
    openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js